/* TerminalComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./TerminalRenderer");
const _ = require("lodash");

class TerminalComponent extends EventEmitter {
    constructor() {
        super();
        this._renderer = new Renderer(this);

        this._buffer = "";

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._renderer = undefined;
            this._buffer = undefined;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _appendDataToBuffer(data) {
        this._buffer += data;
    }
    _clearBuffer() {
        this._buffer = "";
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get buffer() {
        return this.getBuffer();
    }
    getBuffer() {
        return this._buffer;
    }
    writeError(data) {
        this.write(data, { error: true });
    }
    writelnError(data) {
        this.writeln(data, { error: true, newLine: true });
    }
    write(data, opts) {
        let str = data;
        if (!_.isString(data)) {
            str = JSON.stringify(data, null, "  ");
        }
        //if an error message
        if (_.get(opts, "error")) {
            str = "[31m" + str + "[m";
        }
        //if adding a new line
        if (_.get(opts, "newLine")) {
            str = str + "\r\n";
        }

        //Clean up the string
        str = str.replace(/\r?\n|\r|\\n|\\r\\n/g, "\r\n");

        this._appendDataToBuffer(str);
        this.emit("DataWritten", str, this._buffer);
    }
    writeln(l, opts) {
        let options = _.merge({}, opts, { newLine: true });
        this.write(l, options);
    }
    clear() {
        let prev = this._buffer;
        this._clearBuffer();
        this.emit("Cleared", prev);
    }
    resize() {
        this.emit("Resize");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = TerminalComponent;
